import FormErrors from "@/components/FormErrors/FormErrors";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";
import uuidv4 from "uuid/v4";
import { JSConn } from "@/utilities/js-conn";
import { map as Rmap } from "ramda";

export default {
  name: "clientEditForm",
  components: {
    FormErrors,
    LoadingAnimation,
  },
  props: {
    clientId: String,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Client...",
      hasFormErrors: false,
      cancelParams: { name: "clients" },
      formErrors: [],
      client: {
        name: null,
      },
    };
  },
  created() {
    if (this.clientId === "new") {
      this.client = {
        id: uuidv4(),
        manager: null,
        name: "New",
        status: "active",
        client_phone_numbers_attributes: [
          {
            id: null,
            number: null,
            classification: "cell",
            sort_order: 100,
            _destroy: false,
          },
        ],
      };
      this.dataLoaded = true;
      this.$nextTick(() => this.$refs.firstInput.select());
    } else {
      const jsConn = new JSConn();

      jsConn.formParams = {
        id: this.clientId,
      };

      this.$store.dispatch("needClient", jsConn).then(() => {
        // correct client is in the store
        this.client = {
          name: this.apiClient.name,
          manager: this.apiClient.manager,
          id: this.apiClient.id,
          status: this.apiClient.status,
          client_phone_numbers_attributes: this.prepareClientPhoneNumbers(),
        };
        this.dataLoaded = true;
        this.cancelParams = {
          name: "clientShow",
          params: { clientId: this.clientId },
        };
        this.$nextTick(() => this.$refs.firstInput.select());
      });
    }
  },
  methods: {
    submitForm(evt) {
      evt.preventDefault();
      const jsConn = new JSConn();
      // need to do some special handling on the phone numbers
      // they are a has_many association on the client model
      // if the number is blank, set destroy to true
      let cleanedNumbers = Rmap(ph => {
        if (ph.number) {
          return {
            ...ph,
          };
        } else {
          return {
            ...ph,
            _destroy: true,
          };
        }
      }, this.client.client_phone_numbers_attributes);
      this.client.client_phone_numbers_attributes = cleanedNumbers;

      jsConn.formParams = this.client;
      jsConn.toRoutePath = "/clients";

      let storeDispatch;

      if (this.clientId === "new") {
        storeDispatch = "createClient";
      } else {
        storeDispatch = "updateClient";
      }

      this.$store
        .dispatch(storeDispatch, jsConn)
        .then(jsConn => {
          this.$router.push(jsConn.toRoutePath);
          return Promise.resolve(jsConn);
        })
        .catch(jsConn => {
          this.hasFormErrors = true;
          this.formErrors = jsConn.error["response"]["data"];
        });
    },
    prepareClientPhoneNumbers() {
      if (this.apiClient.phone_numbers.length > 0) {
        return Rmap(ph => {
          return {
            id: ph.id,
            number: ph.number,
            classification: ph.classification,
            sort_order: ph.sort_order,
            _destroy: false,
          };
        }, this.apiClient.phone_numbers);
      } else {
        // if there are no phone numbers, there should still be
        // the option to add one
        return [
          {
            id: null,
            number: null,
            classification: "cell",
            sort_order: 100,
            _destroy: false,
          },
        ];
      }
    },
    showDeleteModal() {
      this.$refs["deleteModal"].show();
    },
    hideDeleteModal() {
      this.$refs["deleteModal"].hide();
    },
    deleteClient() {
      const jsConn = new JSConn();
      jsConn.toRoutePath = "/clients";
      jsConn.formParams = {
        id: this.clientId,
      };
      this.$store.dispatch("deleteClient", jsConn).then(jsConn => {
        this.$router.push(jsConn.toRoutePath);
        return Promise.resolve(jsConn);
      });
    },
  },
  computed: {
    apiClient: function() {
      return this.$store.getters.client;
    },
  },
};
